/* src/app/components/article-option-group-single/article-option-group-single.component.scss */
ion-radio-group {
  width: 100%;
  border-radius: 0px;
  padding: 5px;
  display: block;
}
.price {
  font-size: 14px;
  color: black;
  margin-inline-start: 4px;
}
ion-label {
  font-family: AppFont, sans-serif;
  display: block;
  font-size: 14px;
}
ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}
app-tag {
  display: inline-block;
}
ion-item {
  background: #FFFFFF;
  border-radius: 0px;
  --padding-end: 0px;
  --inner-padding-end: 2px;
  margin: 10px 0px;
}
.item-img {
  width: 50px;
  padding: 7px;
}
ion-radio::part(container) {
  border: none;
  background-size: contain;
}
ion-radio::part(mark) {
  background: none;
  transition: none;
  transform: none;
  border-radius: 0;
}
ion-radio.radio-checked::part(container) {
  background: var(--ion-color-primary);
  border-color: transparent;
}
ion-radio.radio-checked::part(mark) {
  width: 6px;
  height: 10px;
  border-width: 0px 2px 2px 0px;
  border-style: solid;
  border-color: #fff;
  transform: rotate(45deg);
}
.text_wrap {
  text-align: left;
  text-wrap: wrap;
  white-space: normal;
  word-break: break-word;
}
.text_wrap span {
  color: #1A1A18 !important;
  font-family: AppFont, sans-serif !important;
  display: flex;
  letter-spacing: -0.5px;
}
.mehr-articles {
  width: fit-content;
}
.mehr-articles div {
  background: white;
  border: 1px solid black;
  padding: 5px 10px;
  border-radius: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mehr-articles div h3 {
  margin-right: 20px;
}
.mehr-articles div ion-icon {
  color: black;
  margin-left: 15px;
  rotate: 0deg;
  transition: rotate 0.7s;
}
.mehr-articles div ion-icon.rotate {
  rotate: 180deg;
}
.ion-text-wrap {
  visibility: visible;
  transition: visibility 1.5s ease-in-out;
}
/*# sourceMappingURL=article-option-group-single.component.css.map */
